import { ReactNode } from 'react'

import { Stack, Typography } from '@mui/material'

import { useCreateDate, useFormatDate, useFormatTime } from '@/hooks'

interface Props {
  sentTs: number
  status?: ReactNode
}

export function Status(props: Props) {
  const { sentTs, status } = props

  const date = useCreateDate(sentTs)
  const formattedDate = useFormatDate(date)
  const formattedTime = useFormatTime(date)

  return (
    <Stack direction="row" spacing={1}>
      <Typography variant="caption" color="text.secondary">
        {formattedTime} • {formattedDate}
      </Typography>
      {status}
    </Stack>
  )
}
